import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "../assets/styles/sidebar.css";
import logo from "../assets/images/logo.png";

export const menuItems = [
  {
    label: "Main",
    icon: "pi pi-th-large",
    items: [
      {
        label: "Dashboard",
        path: "/ProfileDash",
        icon: "pi pi-home",
        permissionName: "Home",
      },
      {
        label: "Admin Dashboard",
        path: "/dashboard",
        icon: "pi pi-briefcase",
      },
    ],
  },
  {
    label: "Users & Roles",
    icon: "pi pi-users",
    items: [
      {
        label: "Users",
        path: "/users",
        icon: "pi pi-user-plus",
      },
      {
        label: "Customers",
        path: "/customers",
        icon: "pi pi-user",
      },
      {
        label: "Vendors",
        path: "/vendors",
        icon: "pi pi-building",
      },
    ],
  },
  {
    label: "Catalogue",
    icon: "pi pi-box",
    items: [
      {
        label: "Categories",
        path: "/categories",
        icon: "pi pi-tags",
      },
      {
        label: "Option Templates",
        path: "/option-templates",
        icon: "pi pi-sliders-h",
      },
      {
        label: "Products",
        path: "/products",
        icon: "pi pi-shopping-cart",
      },
      {
        label: "HSN & GST",
        path: "/tax-classes",
        icon: "pi pi-percentage",
      },
      {
        label: "Collections",
        path: "/collections",
        icon: "pi pi-folder",
      },
      {
        label: "Forms",
        path: "/forms",
        icon: "pi pi-file-edit",
      },
    ],
  },
  {
    label: "Sales",
    icon: "pi pi-chart-line",
    items: [
      {
        label: "Orders",
        path: "/orders",
        icon: "pi pi-shopping-bag",
      },
      {
        label: "Questionnaires",
        path: "/questionnaires",
        icon: "pi pi-file-edit",
        permissionName: "Orders",
      },
      {
        label: "Production",
        path: "/production",
        icon: "pi pi-sliders-h",
        permissionName: "Orders",
      },
      {
        label: "Invoices",
        path: "/invoices",
        icon: "pi pi-receipt",
      },
      {
        label: "Ledger",
        path: "/ledger",
        icon: "pi pi-book",
      },
      {
        label: "Disputes",
        path: "/disputes",
        icon: "pi pi-comments",
      },
    ],
  },
  {
    label: "System",
    icon: "pi pi-cog",
    items: [
      {
        label: "Notifications",
        path: "/notifications",
        icon: "pi pi-bell",
      },
      {
        label: "Notification Control",
        path: "/notification-control",
        icon: "pi pi-send",
      },
      {
        label: "Roles & Permissions",
        path: "/roles-permissions",
        icon: "pi pi-shield",
      },
      {
        label: "Settings",
        path: "/settings",
        icon: "pi pi-cog",
      },
      {
        label: "Maintenance",
        path: "/maintenance",
        icon: "pi pi-wrench",
      },
      {
        label: "Login Security",
        path: "/login-security",
        icon: "pi pi-lock",
      },
      {
        label: "Promotional Popups",
        path: "/promotions",
        icon: "pi pi-megaphone",
      },
      {
        label: "Email Newsletters",
        path: "/newsletters",
        icon: "pi pi-envelope",
      },
    ],
  },
];

const getActiveGroup = (pathname) => {
  const activeGroup = menuItems.find((group) =>
    group.items.some((item) => pathname.startsWith(item.path))
  );

  return activeGroup?.label || "Main";
};

const Sidebar = ({
  isOpen = false,
  isCollapsed = false,
  onClose,
  onToggleCollapse,
}) => {
  const location = useLocation();

  const [openGroup, setOpenGroup] = useState(() =>
    getActiveGroup(location.pathname)
  );

  useEffect(() => {
    const activeGroup = getActiveGroup(location.pathname);

    if (activeGroup) {
      setOpenGroup(activeGroup);
    }
  }, [location.pathname]);

  const toggleGroup = (label) => {
    setOpenGroup((previous) =>
      previous === label ? null : label
    );
  };

  return (
    <aside
      id="admin-navigation"
      className={`admin-sidebar ${isOpen ? "mobile-open" : ""} ${isCollapsed ? "collapsed" : ""
        }`}
      aria-label="Admin navigation"
    >
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <img
            src={logo}
            alt="Wedding Stationery"
            className="logo"
          />
        </div>

        <div className="sidebar-brand">
          <h2>Admin Panel</h2>
          <p>Wedding Stationery</p>
        </div>

        <button
          type="button"
          className="sidebar-close-button"
          aria-label="Close navigation menu"
          onClick={onClose}
        >
          <i className="pi pi-times" />
        </button>
      </div>

      <div className="sidebar-menu-title">
        <span>Workspace</span>
      </div>

      <nav className="sidebar-nav grouped-sidebar-nav">
        {menuItems.map((group) => {
          const isOpen = openGroup === group.label;

          const hasActiveItem = group.items.some((item) =>
            location.pathname.startsWith(item.path)
          );

          return (
            <div
              className={`sidebar-group ${isOpen ? "open" : ""
                } ${hasActiveItem ? "has-active" : ""}`}
              key={group.label}
            >
              <button
                type="button"
                className="sidebar-group-toggle"
                data-tour-group={group.label}
                onClick={() => toggleGroup(group.label)}
                aria-expanded={isOpen}
              >
                <div className="sidebar-group-left">
                  <span className="sidebar-group-icon">
                    <i className={group.icon} />
                  </span>

                  <span className="sidebar-group-label">
                    {group.label}
                  </span>
                </div>

                <span
                  className={`sidebar-chevron ${isOpen ? "open" : ""
                    }`}
                >
                  <i className="pi pi-chevron-down" />
                </span>
              </button>

              <div
                className={`sidebar-submenu ${isOpen ? "open" : ""
                  }`}
              >
                <div className="sidebar-submenu-inner">
                  {group.items.map((item) => (
                    <NavLink
                      key={item.path}
                      to={item.path}
                      data-tour-page={item.path}
                      className={({ isActive }) =>
                        isActive
                          ? "sidebar-link active"
                          : "sidebar-link"
                      }
                      onClick={onClose}
                      title={isCollapsed ? item.label : undefined}
                    >
                      <span className="sidebar-link-icon">
                        <i className={item.icon} />
                      </span>

                      <span className="sidebar-link-label">
                        {item.label}
                      </span>

                      <span className="sidebar-link-arrow">
                        <i className="pi pi-angle-right" />
                      </span>
                    </NavLink>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </nav>

      <button
        type="button"
        className="sidebar-collapse-button"
        onClick={onToggleCollapse}
        aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        <i
          className={`pi ${isCollapsed ? "pi-angle-double-right" : "pi-angle-double-left"
            }`}
        />
        <span>{isCollapsed ? "Expand" : "Collapse sidebar"}</span>
      </button>
    </aside>
  );
};

export default Sidebar;
